import type { SVGProps } from "react";
// generated from UserSquare.svg — do not edit manually
// prettier-ignore
export default function UserSquare(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 19 22 H 22 V 2 H 2 V 22 H 5 M 19 22 H 5 M 19 22 C 19 19.791 17.209 18 15 18 H 9 C 6.791 18 5 19.791 5 22 M 16.5 10.5 C 16.5 12.985 14.485 15 12 15 C 9.515 15 7.5 12.985 7.5 10.5 C 7.5 8.015 9.515 6 12 6 C 14.485 6 16.5 8.015 16.5 10.5 Z" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
